import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, FilterButton, Menu } from '@pocketlaw/tetris';
import { SearchableMenu, SearchableMenuMultiSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { MultiselectOperatorItem } from './MultiselectOperatorItem';
import { useFilter } from '../useFilter';
export function MultiselectOperator(props) {
    var _a, _b;
    const { items, name } = props;
    const [open, setOpen] = useState(false);
    const filter = useFilter(name);
    const selectedIds = (((_a = filter.stagedValue) === null || _a === void 0 ? void 0 : _a[filter.operator]) || []);
    const [firstSelection] = selectedIds || [];
    const secondaryCount = selectedIds.length > 1 ? `+${selectedIds.length - 1}` : '';
    const selectedTitle = (_b = items.find((item) => item.id === firstSelection)) === null || _b === void 0 ? void 0 : _b.title;
    const secondaryText = selectedIds.length ? `${selectedTitle} ${secondaryCount}` : '';
    const handleOnSelect = (item) => {
        const { id } = item;
        const selected = selectedIds.includes(id);
        if (!selected) {
            const newData = { [filter.operator]: [...selectedIds, id] };
            filter.setStagedValue(newData);
            return;
        }
        if (selectedIds.length === 1) {
            filter.resetValue();
        }
        else {
            const newData = {
                [filter.operator]: selectedIds.filter((selectedItem) => selectedItem !== id),
            };
            filter.setStagedValue(newData);
        }
    };
    const handleCommitFilterValue = () => {
        setOpen(false);
        filter.commitValue();
    };
    return (<SearchableMenu items={items} keys={['title']} open={open} onClose={handleCommitFilterValue} placeholder={t({
            message: 'Search',
            comment: 'Multi select filter search input placeholder',
        })} renderTarget={<FilterButton appearance={filter.isTouched ? 'draft' : 'default'} onClick={() => setOpen(!open)}>
          {secondaryText || <Trans comment="Multi select filter button">Select value</Trans>}
        </FilterButton>}>
      <SearchableMenuMultiSelectList selected={selectedIds} renderItem={({ title, subtitle, type }) => (<MultiselectOperatorItem title={title} subtitle={subtitle} type={type}/>)} onSelect={handleOnSelect}/>
      {filter.hasStagedValues && (<Menu.Footer>
          <Button $stretch type="button" size="xs" onClick={handleCommitFilterValue}>
            <Trans comment="Search filter menu - Apply filters">Apply filter</Trans>
          </Button>
        </Menu.Footer>)}
    </SearchableMenu>);
}
